import { ReportData } from "model/reportData.model"
import { VisitantesRestauranteReport } from "model/reports/visitantesRestaurante.report.model"
import { getStartAndEndOfFifteenMinutes, toDateMonthYearHourMinuteString } from "utils/date.util"

export function createVisitantesRestauranteReportData(data?: VisitantesRestauranteReport[]): ReportData {
    const rows = data?.map(_ => {
        let startDate: Date | undefined = undefined
        let endDate: Date | undefined = undefined
        if(_.date){
            const {startDate: _startDate, endDate: _endDate} = getStartAndEndOfFifteenMinutes(_.date)
            startDate = _startDate
            endDate = _endDate
        }
        return [
            // _.building ?? '---' ,
            // _.area ?? '---' ,
            _.room ?? '---',
            toDateMonthYearHourMinuteString(startDate) ?? '---',
            toDateMonthYearHourMinuteString(endDate) ?? '---',
            _.value ?? '---'
        ]
    }) ?? []
    return {
        titles: [
            // 'Prédio', 
            // 'Andar', 
            'Restaurante', 
            'De', 
            'Até',
            'Número de visitantes'
        ],
        rows: rows
    }
}